module.exports = __webpack_public_path__ + "img/i_empty_result.9cd33abe.svg";